import NotInterestedIcon from '@mui/icons-material/NotInterested';
import { useEffect } from 'react';
import { PropsWithOnLoad } from '../../type';
import { ResultContentContainer } from './ResultContentContainer';

export const ResultContentUnsupported: React.FC<PropsWithOnLoad> = ({ onLoad }) => {
    useEffect(() => {
        onLoad?.();
    }, [onLoad]);

    return (
        <ResultContentContainer>
            <NotInterestedIcon sx={{ fontSize: 200, color: (theme) => (theme.vars || theme).palette.error.main, m: 5 }} />
        </ResultContentContainer>
    );
};
